import CardTemp from './CardTemplate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faParking } from '@fortawesome/free-solid-svg-icons';
library.add(faParking);

function CornellTabContent() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
      }}
    >
      <CardTemp
        cardLink="/CornellAnswersList"
        cardIcon={<FontAwesomeIcon icon={faParking} />}
        imgSrc={require('./Parking Symbol1.jpg')}
        imgTitle=" Cornell Parking Summary"
        def1=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Locations:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>6</span>
        </span>
        def2=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Hours: </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            24 Hours 7 Days
          </span>
        </span>
        def3=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Waiting List:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Yes</span>
        </span>
        def4=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Wait for Parking:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Two Years+</span>
        </span>
        def5=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Storage:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            NYP Housing Only
          </span>
        </span>
        def6=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Licenses:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Public</span>
        </span>
        def7=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Parking Office Tel:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>212-746-7357</span>
          <br />
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            {' '}
            Email:{' '}
            <a href="mailto:parkingnyp-east@nyp.org">parkingnyp-east@nyp.org</a>
          </span>
        </span>
      />
      <CardTemp
        cardLink="/AnnexAnswersList"
        cardIcon={<FontAwesomeIcon icon={faParking} />}
        imgSrc={require('./Annex.jpg')}
        imgTitle=" Annex Building Garage"
        def1=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Address:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            519 East 70th Street New York NY 1002
          </span>
        </span>
        def2=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Facility:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Garage</span>
        </span>
        def3=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Hours: </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            24 Hours 7 Days
          </span>
        </span>
        def4=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Operation:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            Valet/Self-Park
          </span>
        </span>
        def5=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Capacity:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>250 Cars</span>
        </span>
        def6=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            License:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Public</span>
        </span>
        def7=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Contact:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            (212) 746-1978 or
          </span>
          <br />
          <span style={{ color: 'blue', fontSize: '12px' }}>
            <a href="mailto:nypparking-east@nyp.org">nypparking-east@nyp.org</a>
          </span>
        </span>
      />

      <CardTemp
        cardLink="/DHKAnswersList"
        cardIcon={<FontAwesomeIcon icon={faParking} />}
        imgSrc={require('./DHK.jpg')}
        imgTitle=" David H Koch (DHK) Garage"
        def1=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Address:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            445 East 68th Street New York NY 10065
          </span>
        </span>
        def2=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Facility:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Garage</span>
        </span>
        def3=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Hours: </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            24 Hours 7 Days
          </span>
        </span>
        def4=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Operation:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Valet Only</span>
        </span>
        def5=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Capacity:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>124 Cars</span>
        </span>
        def6=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            License:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Public</span>
        </span>
        def7=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Contact:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            (212) 746-1866 or
          </span>
          <br />
          <span style={{ color: 'blue', fontSize: '12px' }}>
            <a href="mailto:nypparking-east@nyp.org">nypparking-east@nyp.org</a>
          </span>
        </span>
      />

      <CardTemp
        cardLink="/GreenbergAnswersList"
        cardIcon={<FontAwesomeIcon icon={faParking} />}
        imgSrc={require('./Greenberg.jpg')}
        imgTitle=" Greenberg Hospital Garage"
        def1=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Address:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            525 East 68th Street New York NY 10021
          </span>
        </span>
        def2=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Facility:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Garage</span>
        </span>
        def3=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Hours: </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            24 Hours 7 Days
          </span>
        </span>
        def4=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Operation:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Valet Only</span>
        </span>
        def5=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Capacity:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>275 Cars</span>
        </span>
        def6=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            License:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Public</span>
        </span>
        def7=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Contact:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            (212) 746-1866 or
          </span>
          <br />
          <span style={{ color: 'blue', fontSize: '12px' }}>
            <a href="mailto:nypparking-east@nyp.org">nypparking-east@nyp.org</a>
          </span>
        </span>
      />

      <CardTemp
        cardLink="/HelmsleyAnswersList"
        cardIcon={<FontAwesomeIcon icon={faParking} />}
        imgSrc={require('./Helmsley.jpg')}
        imgTitle=" Helmsley Tower Garage"
        def1=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Address:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            515 East 70th Street New York NY 10021
          </span>
        </span>
        def2=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Facility:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Garage</span>
        </span>
        def3=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Hours: </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            24 Hours 7 Days
          </span>
        </span>
        def4=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Operation:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Valet Only</span>
        </span>
        def5=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Capacity:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>175 Cars</span>
        </span>
        def6=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            License:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Public</span>
        </span>
        def7=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Contact:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            (212) 746-1974 or
          </span>
          <br />
          <span style={{ color: 'blue', fontSize: '12px' }}>
            <a href="mailto:nypparking-east@nyp.org">nypparking-east@nyp.org</a>
          </span>
        </span>
      />

      <CardTemp
        cardLink="/PaysonAnswersList"
        cardIcon={<FontAwesomeIcon icon={faParking} />}
        imgSrc={require('./Payson.jpg')}
        imgTitle=" Payson House Garage"
        def1=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Address:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            425 East 71th Street New York NY 10021
          </span>
        </span>
        def2=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Facility:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Garage</span>
        </span>
        def3=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Hours: </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            24 Hours 7 Days
          </span>
        </span>
        def4=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Operation:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Valet Only</span>
        </span>
        def5=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Capacity:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>175 Cars</span>
        </span>
        def6=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            License:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Public</span>
        </span>
        def7=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Contact:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            (212) 746-1977 or
          </span>
          <br />
          <span style={{ color: 'blue', fontSize: '12px' }}>
            <a href="mailto:nypparking-east@nyp.org">nypparking-east@nyp.org</a>
          </span>
        </span>
      />
      <CardTemp
        cardLink="/ColemanAnswersList"
        cardIcon={<FontAwesomeIcon icon={faParking} />}
        imgSrc={require('./Payson.jpg')}
        imgTitle=" Coleman Building Garage"
        def1=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Address:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            1330 1st Avenue New York NY 10021
          </span>
        </span>
        def2=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Facility:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Garage</span>
        </span>
        def3=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Hours: </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            24 Hours 7 Days
          </span>
        </span>
        def4=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Operation:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Valet Only</span>
        </span>
        def5=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Capacity:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>95 Cars</span>
        </span>
        def6=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            License:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            Employees Only
          </span>
        </span>
        def7=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Contact:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            (212) 746-1978 or
          </span>
          <br />
          <span style={{ color: 'blue', fontSize: '12px' }}>
            <a href="mailto:nypparking-east@nyp.org">nypparking-east@nyp.org</a>
          </span>
        </span>
      />
    </div>
  );
}
export default CornellTabContent;
